import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { classNames } from '../../utils/styles';
import { Button, SectionContainer } from '../styles';
import { Avatar, ButtonContainer, Content, Header } from './styles';
export const Welcome = ({ section }) => {
    const theme = useTheme();
    const title = section.exibitionName;
    const { logo, featuredTitle, supportingText, buttonTitle, buttonLink } = section;
    const showHeader = !!title || !!logo;
    const showContentSection = !!featuredTitle || !!supportingText;
    const showButtonSection = !!buttonTitle && !!buttonLink;
    const buttonOnClickHandler = () => window.open(buttonLink);
    return (_jsxs(_Fragment, { children: [showHeader && (_jsx(SectionContainer, { children: _jsxs(Header, { className: classNames({
                        'avatar-present': !!logo,
                    }), children: [title && (_jsx("div", { className: classNames('title', {
                                'full-width': !logo,
                            }), children: _jsx("h3", { children: title }) })), logo && (_jsx("div", { className: classNames('avatar', {
                                'full-width': !title,
                            }), children: _jsx(Avatar, { "$logo": logo }) }))] }) })), showContentSection && (_jsx(SectionContainer, { className: classNames({
                    npb: showButtonSection,
                }), children: _jsxs(Content, { children: [featuredTitle && (_jsx("div", { children: _jsx("h1", { children: featuredTitle }) })), supportingText && (_jsx("div", { className: classNames('supporting-text', {
                                mt: !!featuredTitle,
                            }), children: _jsx("h5", { children: supportingText }) }))] }) })), showButtonSection && (_jsx(SectionContainer, { children: _jsx(ButtonContainer, { children: _jsx(Button, { onClick: () => buttonOnClickHandler(), textColor: theme.textButtons, backgroundColor: theme.buttons, children: buttonTitle }) }) }))] }));
};
